/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.Inventory {

    import fld = OpeningStockItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class OpeningStockItemsEditor extends _Ext.ItemGridEditor<OpeningStockItemsRow> {


        protected getColumnsKey() { return "Inventory.OpeningStockItems"; }
        protected getDialogType() { return OpeningStockItemsDialog; }
        protected getLocalTextPrefix() { return OpeningStockItemsRow.localTextPrefix; }
        protected form: OpeningStockItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public DeptId: number;
        private GenSKU: boolean = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public MasterEntity: any;
        isEditable: boolean;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.toolbar.findButton('add-button').find('.button-inner').text('New Product');

            this.slickGrid.onRender.subscribe(() => {
                // call of the function that will bind the editors with the fields (<input>) of the html page
                this.SetInlineLookupEditor();
            });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as OpeningStockDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            });

        }

        private Master;
        public setEditValue(source: OpeningStockRow, property) {
            ///super.setOwnerEntity(source);
            this.Master = source;
            super.setEditValue(source, property);
        }

        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        private SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            for (let Item in Items) {
                this.InlineLookup(Item, Items);
            }
        }

        private InlineLookup(RowIndex: string, Items: OpeningStockItemsRow[]) {
            if (!$("#LocId" + RowIndex).hasClass("select2-offscreen")) {
                // Editor creation and field binding
                let opt: Serenity.LookupEditorOptions = {
                    lookupKey: OMS.DepartmentMasterRow.lookupKey
                };
                var Editor = new TabAurous.InlineLookupEditor($("#LocId" + RowIndex), opt);
                Editor.value = Q.toId(Items[RowIndex].DepartmentId);

                //Editor.cascadeField = "DepartmentTypeId";
                //Editor.cascadeValue = "141"
                Editor.changeSelect2(e => {
                    // assigning the new value selected in the line
                    Items[RowIndex].DepartmentId = Q.toId(Editor.value);
                });
            }
        }



        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            Department.referencedFields = [fld.DepartmentId];
            Department.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="LocId' + ctx.row + '" title="Location" />';
            };

            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = wt;
            Q.first(columns, x => x.field === fld.DiscountPer).format = num;
            Q.first(columns, x => x.field === fld.Discount).format = amt;
            Q.first(columns, x => x.field === fld.UnitRate).format = amt;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }

        setMasterValues() {
            this.RateListId = (this.parentDialog as OpeningStockDialog).RateListId;
            this.LaborListId = (this.parentDialog as OpeningStockDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as OpeningStockDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as OpeningStockDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as OpeningStockDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as OpeningStockDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as OpeningStockDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as OpeningStockDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as OpeningStockDialog).form.PartyId.value);
        }

        //#region  ItemGrid Inline Editor

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight || field === fld.Discount || field === fld.UnitRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId == 101) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.NetAmount * value;
                    item.Weight = (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = (item.NetWeight / item.Pieces) * value;
                    item.BOMDetails.forEach(function (x) {
                        var Pieces = (x.Pieces / item.Pieces) * value;
                        var Weight = (x.Weight / item.Pieces) * value;
                        if (x.CalcOnId == 3) {
                            x.BomAmount = x.BomRate * Pieces;
                        }
                        else {
                            if (x.ItemTypeId == 104)
                                x.BomAmount = x.BomRate * Weight * x.Purity;
                            else
                                x.BomAmount = x.BomRate * Weight;
                        }
                        x.Pieces = Pieces;
                        x.Weight = Weight;
                    })
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                }
                item[field] = value;
            }
            // **** Allow to Set Pcs to Zero for RM ****
            if (field === fld.Pieces && item.ItemTypeId != 101) {
                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = ((item.UnitRate + labr) / item.Pieces) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // **** Allow to Set Weight for RM ****
            if (field === fld.Weight && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = ((item.UnitRate + labr) / item.Weight) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;

                }


                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;

                }

                item[field] = value;
            }

            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item.DiscountPer = (value / item.NetAmount) * 100;
                item[field] = value;

            }

            // *** Calculate Discount % ***
            if (field === fld.DiscountPer && value >= 0) {
                var Discount = (item.NetAmount * value) / 100
                item.GrossAmount = item.NetAmount - Discount;
                item.Discount = Discount;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            this.element.trigger('dialogclose');

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }

        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();

            var addbutton = buttons.filter(x => x.cssClass == "add-button")[0];
            addbutton.hotkey = 'alt+n';
            addbutton.hint = 'alt+n';


            // #region Add Select Button to Grid Editor
            buttons.push({
                title: "Select Designs",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var grid = Common.ProductSelectGrid;
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                     
                    var filters: _Ext.SelectGridFilters = {
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                       // let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });

                        let selectedItems2 = selectedItems

                        var ItemDetails = ItemGridHelper.SetPurchaseItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup, this.GenSKU, true);
                        this.setData(ItemDetails);

                        // #endregion

                        // #endregion
                    }

                    pickerDialog.dialogOpen();
                }
            });


            // #endregion

            buttons.push({
                title: "Import Designs",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {

                    var dialog = new Common.ProductImportExcelDialog();

                    dialog.element.on('dialogclose', () => {
                        var products = dialog.products;
                        for (let product of products) {
                            product.RefTransId = 0;
                            product.RefTransItemId = 0;
                            product.RefVoucherId = 0;
                            product.StockAllocation = false;
                            product.DepartmentId = 1;
                            product[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(product);
                        }

                        this.refresh();

                        dialog = null;
                    });

                    dialog.dialogOpen();
                },
            });
            buttons.push({
                title: 'Labour Import',
                cssClass: 'import-xlsx-button',
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new Common.ProductLabourImportDialog();
                    dialog.createlabour = false;
                    dialog.element.on('dialogclose', () => {

                        var labours = dialog.labors;
                        for (var i = 0; i < labours.length; i++) {
                            var labour = labours[i];
                            var item = this.view.getItems().filter(x => x.ProductId == labour.ProductId)[0];
                            if (item != null) {
                                var newlabour: OpeningStockLaborRow = {
                                    AttributeId: item.AttributeId,
                                    CalcOnId: labour.CalcOnId,
                                    LabourAmount: labour.LabourAmount,
                                    LabourRate: labour.LabourRate,
                                    CCLabourAmount: labour.LabourAmount,
                                    Pieces: item.Pieces,
                                    Weight: item.Weight,
                                    WstPer: labour.WstPer,
                                    WstWt: labour.WstWt,
                                    ProcessId: labour.ProcessId,
                                    
                                }

                                item.LaborDetails.push(newlabour);

                                var id = this.id(item);
                                this.view.updateItem(id, item);
                            }
                        }
                        (this.parentDialog as OpeningStockDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);

                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });
            return buttons;
        }

        setData(ItemDetails: any[]) { 
            for (let Itemdetail of ItemDetails) {
                Itemdetail.RefTransId = 0;
                Itemdetail.RefTransItemId = 0;
                Itemdetail.RefVoucherId = 0;
                Itemdetail.StockAllocation = false;
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++; 
                this.view.addItem(Itemdetail);
            }
        }
        // #endregion

    }
}